import { useShowsMaxDiscount, useShowsPurchase } from '@/shared/session/profiles';

/**
 * The articles of a tariff, from the search or from one version: the same columns
 * everywhere, decided by what the person may see **and** the counter mode.
 *
 * The API leaves empty what a profile may not see (ADR 0042 of the back); a column that
 * would always be empty is not drawn. The counter mode hides the maximum discount and
 * the purchase while a customer looks, even for whoever may see them.
 */
export interface PriceSight {
  maxDiscount: boolean;
  purchase: boolean;
}

export function usePriceSight(): PriceSight {
  return { maxDiscount: useShowsMaxDiscount(), purchase: useShowsPurchase() };
}
